import { render } from "./FormFuther.vue?vue&type=template&id=4cfc7970"
import script from "./FormFuther.vue?vue&type=script&lang=js"
export * from "./FormFuther.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__